module.exports = __webpack_public_path__ + "static/img/h_4@2x.97640006.png";